import Vue from "vue";
import VueChartList from "vue-chartist";
import "chartist/dist/chartist.min.css";
import "chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css";

Vue.use(VueChartList);
